<script setup lang="ts">
    import { IList } from '@/js/models/list-item';
    import { ITopListWidget } from '@/js/services/api/widget/types';
    import { onMounted, ref } from 'vue';
    import ParsedMarkdown from '../ParsedMarkdown.vue';

    const props = withDefaults(defineProps<{ data?: Object; widget?: ITopListWidget }>(), {
        widget: undefined,
        data: () => {
            return {
                title: '',
                items: [],
            } as IList;
        },
    });

    const list = ref<IList>({
        title: '',
        items: [],
    });

    onMounted(async () => {
        if (props.widget) {
            list.value = props.widget.listWidget as IList;
        } else if (props.data) {
            list.value = props.data as IList;
        }
    });
</script>

<template>
    <div class="w-3xl max-w-full">
        <h2 class="font-medium mb-4">
            {{ list.title }}
        </h2>

        <ol class="grid grid-cols-1 @md:grid-cols-2 gap-4 custom-counter">
            <li v-for="item in list.items" :key="item.title">
                <h3
                    class="bg-[var(--color,var(--color-gray-dark))] text-white rounded-lg font-medium text-xs px-2.5 py-1.5 flex items-center"
                    :style="'--color: var(' + (item['background-color'] || '') + ')'"
                >
                    <span data-counter-slot aria-hidden="true" class="text-lg block mr-2" />
                    {{ item.title }}
                </h3>
                <p class="text-xs border border-gray-light p-2.5 rounded-lg mt-1">
                    <ParsedMarkdown :markdown="item.description" />
                </p>
            </li>
        </ol>
    </div>
</template>
